import type { Server } from '@/models/server.ts';
import type { Message } from '@/models/message.ts';
import type { ServerEvent } from '@/models/server-event.ts';
import type { User } from '@/models/user.ts';
import { UserParticipantPosition } from '@/models/user-participant-position.ts';
import { TkitServer } from '@/models/tkit-server.ts';

export enum ChannelType {
  TEXT = 'TEXT',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  STREAM = 'STREAM',
  TRIBUNE = 'TRIBUNE',
}

export interface Channel {
  id: string;
  name: string;
  type: ChannelType;
  profileId: string;
  profile: User;
  isPrivate: boolean;
  serverId: string;
  server: Server;
  messages?: Message[];
  serverEvents?: ServerEvent;
  userParticipantPosition: UserParticipantPosition[];
  maxParticipants: number;
  preview: boolean;
  position: number;
  tkitServer: TkitServer;
  tkitServerId?: string;
  createdAt: Date;
  updatedAt: Date;
}
